/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CallToAction from 'src/components/CallToAction';
import * as CdpPageView from 'src/components/CdpPageView';
import * as ContentBlock from 'src/components/ContentBlock';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as GTM from 'src/components/GTM';
import * as OneTrust from 'src/components/OneTrust';
import * as BannerQuickLinks from 'src/components/Blocks/BannerQuickLinks';
import * as IFrame from 'src/components/Blocks/IFrame';
import * as Infographics from 'src/components/Blocks/Infographics';
import * as CustomScroll from 'src/components/Functional/CustomScroll';
import * as Tabs from 'src/components/Functional/Tabs';
import * as ArticleFilters from 'src/components/Functional/ArticleFilterBar/ArticleFilters';
import * as SelectedFilters from 'src/components/Functional/ArticleFilterBar/SelectedFilters';
import * as BaseFilter from 'src/components/Functional/Filters/BaseFilter';
import * as DatePickerFilter from 'src/components/Functional/Filters/DatePickerFilter';
import * as FilterDropdown from 'src/components/Functional/Filters/FilterDropdown';
import * as FilterDropdownOption from 'src/components/Functional/Filters/FilterDropdownOption';
import * as MobileBaseFilters from 'src/components/Functional/Filters/MobileFilter/MobileBaseFilters';
import * as MobileBaseFiltersActions from 'src/components/Functional/Filters/MobileFilter/MobileBaseFiltersActions';
import * as MobileBaseFiltersDropdown from 'src/components/Functional/Filters/MobileFilter/MobileBaseFiltersDropdown';
import * as MobileBaseFiltersDropdownOption from 'src/components/Functional/Filters/MobileFilter/MobileBaseFiltersDropdownOption';
import * as Slider from 'src/components/Functional/Slider/Slider';
import * as SliderNavCircle from 'src/components/Functional/Slider/SliderNavCircle';
import * as AlertMessage from 'src/components/Generic/AlertMessage';
import * as AlertMessageBase from 'src/components/Generic/AlertMessageBase';
import * as Animation from 'src/components/Generic/Animation';
import * as ArticleCardsComponent from 'src/components/Generic/ArticleCardsComponent';
import * as AsideModal from 'src/components/Generic/AsideModal';
import * as BaseHeading from 'src/components/Generic/BaseHeading';
import * as BaseSkeleton from 'src/components/Generic/BaseSkeleton';
import * as Breadcrumbs from 'src/components/Generic/Breadcrumbs';
import * as Checkbox from 'src/components/Generic/Checkbox';
import * as Dropdown from 'src/components/Generic/Dropdown';
import * as ExpandableContent from 'src/components/Generic/ExpandableContent';
import * as FirstLevelTabs from 'src/components/Generic/FirstLevelTabs';
import * as Footer from 'src/components/Generic/Footer';
import * as IntroCopy from 'src/components/Generic/IntroCopy';
import * as ManualDisclaimer from 'src/components/Generic/ManualDisclaimer';
import * as SecondLevelTabs from 'src/components/Generic/SecondLevelTabs';
import * as ShareScreen from 'src/components/Generic/ShareScreen';
import * as SkipToMainContent from 'src/components/Generic/SkipToMainContent';
import * as StateDrivenDropdown from 'src/components/Generic/StateDrivenDropdown';
import * as TeamProfileBase from 'src/components/Generic/TeamProfileBase';
import * as Tooltip from 'src/components/Generic/Tooltip';
import * as AbrdnButton from 'src/components/Generic/Buttons/AbrdnButton';
import * as BackToTopButton from 'src/components/Generic/Buttons/BackToTopButton';
import * as ContainerMain from 'src/components/Generic/Containers/ContainerMain';
import * as AbrdnSelect from 'src/components/Generic/Forms/FormFields/AbrdnSelect';
import * as DatePicker from 'src/components/Generic/Forms/FormFields/DatePicker';
import * as FormCheckbox from 'src/components/Generic/Forms/FormFields/FormCheckbox';
import * as FormElemWrapper from 'src/components/Generic/Forms/FormFields/FormElemWrapper';
import * as InputField from 'src/components/Generic/Forms/FormFields/InputField';
import * as MultipleCheckboxes from 'src/components/Generic/Forms/FormFields/MultipleCheckboxes';
import * as MultiplePicklist from 'src/components/Generic/Forms/FormFields/MultiplePicklist';
import * as Note from 'src/components/Generic/Forms/FormFields/Note';
import * as RadioButton from 'src/components/Generic/Forms/FormFields/RadioButton';
import * as RadioButtonFieldset from 'src/components/Generic/Forms/FormFields/RadioButtonFieldset';
import * as FieldTypeDefiner from 'src/components/Generic/Forms/SalesforceIntegratedForms/FieldTypeDefiner';
import * as FormContext from 'src/components/Generic/Forms/SalesforceIntegratedForms/FormContext';
import * as RepeatableSectionFieldDefiner from 'src/components/Generic/Forms/SalesforceIntegratedForms/RepeatableSectionFieldDefiner';
import * as SalesforceIntegratedForm from 'src/components/Generic/Forms/SalesforceIntegratedForms/SalesforceIntegratedForm';
import * as StepProgress from 'src/components/Generic/Forms/SalesforceIntegratedForms/StepProgress';
import * as StepSelector from 'src/components/Generic/Forms/SalesforceIntegratedForms/StepSelector';
import * as Summary from 'src/components/Generic/Forms/SalesforceIntegratedForms/Summary';
import * as WithFormProvider from 'src/components/Generic/Forms/SalesforceIntegratedForms/WithFormProvider';
import * as SalesforceAlertMessage from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceAlertMessage';
import * as SalesforceCheckBox from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceCheckBox';
import * as SalesforceConditionalRadioButtons from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceConditionalRadioButtons';
import * as SalesforceDateInput from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceDateInput';
import * as SalesforceDropdown from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceDropdown';
import * as SalesforceHiddenField from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceHiddenField';
import * as SalesforceInput from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceInput';
import * as SalesforceRepeatableSubSection from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceRepeatableSubSection';
import * as SalesforceRichTextArea from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceRichTextArea';
import * as SalesforceSortCode from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/SalesforceSortCode';
import * as TemplateComponentType from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/TemplateComponentType';
import * as fieldsMapping from 'src/components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/fieldsMapping';
import * as Header from 'src/components/Generic/Header/Header';
import * as LanguageSelector from 'src/components/Generic/Header/LanguageSelector';
import * as GlobalNavigation from 'src/components/Generic/Header/GlobalNavigation/GlobalNavigation';
import * as GlobalNavigationDropdown from 'src/components/Generic/Header/GlobalNavigation/GlobalNavigationDropdown';
import * as SiteSelector from 'src/components/Generic/Header/GlobalNavigation/SiteSelector';
import * as LanguageSelectorMobile from 'src/components/Generic/Header/MegaNavigation/LanguageSelectorMobile';
import * as MegaNavigation from 'src/components/Generic/Header/MegaNavigation/MegaNavigation';
import * as MegaNavigationtypes from 'src/components/Generic/Header/MegaNavigation/MegaNavigation.types';
import * as MegaNavigationBody from 'src/components/Generic/Header/MegaNavigation/MegaNavigationBody';
import * as MegaNavigationBodyMobile from 'src/components/Generic/Header/MegaNavigation/MegaNavigationBodyMobile';
import * as MegaNavigationMenuItem from 'src/components/Generic/Header/MegaNavigation/MegaNavigationMenuItem';
import * as MobileMenuSiteSelector from 'src/components/Generic/Header/MegaNavigation/MobileMenuSiteSelector';
import * as PromotedContent from 'src/components/Generic/Header/MegaNavigation/PromotedContent';
import * as changeLanguage from 'src/components/Generic/Header/MegaNavigation/changeLanguage';
import * as changeSite from 'src/components/Generic/Header/MegaNavigation/changeSite';
import * as IconChevronQuickLinks from 'src/components/Generic/Icons/IconChevronQuickLinks';
import * as IconStar from 'src/components/Generic/Icons/IconStar';
import * as IconWarning from 'src/components/Generic/Icons/IconWarning';
import * as IconX from 'src/components/Generic/Icons/IconX';
import * as TeamProfilePlaceholder from 'src/components/Generic/Icons/TeamProfilePlaceholder';
import * as index from 'src/components/Generic/Loader/index';
import * as BaseSearch from 'src/components/Generic/SearchBar/BaseSearch';
import * as BaseSearchSuggests from 'src/components/Generic/SearchBar/BaseSearchSuggests';
import * as AbrdnPlaceholders from 'src/components/Generic/SitecoreWrappers/AbrdnPlaceholders';
import * as Image from 'src/components/Generic/SitecoreWrappers/Image';
import * as RichText from 'src/components/Generic/SitecoreWrappers/RichText';
import * as ScLink from 'src/components/Generic/SitecoreWrappers/ScLink';
import * as DisclaimerModal from 'src/components/Modals/DisclaimerModal';
import * as DisclaimerModalContent from 'src/components/Modals/DisclaimerModalContent';
import * as Modal from 'src/components/Modals/Modal';
import * as ModalBody from 'src/components/Modals/ModalBody';
import * as ModalContent from 'src/components/Modals/ModalContent';
import * as ModalHeader from 'src/components/Modals/ModalHeader';
import * as ShareModalContent from 'src/components/Modals/ShareModalContent';
import * as ArticleCards from 'src/components/Pages/ArticleListings/ArticleCards';
import * as ArticleFilterBar from 'src/components/Pages/ArticleListings/ArticleFilterBar';
import * as FilteredArticleCards from 'src/components/Pages/ArticleListings/FilteredArticleCards';
import * as ArticleActionBar from 'src/components/Pages/ArticleParts/ArticleActionBar';
import * as ArticleBottomContainer from 'src/components/Pages/ArticleParts/ArticleBottomContainer';
import * as ArticleChapters from 'src/components/Pages/ArticleParts/ArticleChapters';
import * as ArticleFootnote from 'src/components/Pages/ArticleParts/ArticleFootnote';
import * as ArticleInfogramTile from 'src/components/Pages/ArticleParts/ArticleInfogramTile';
import * as ArticleSubscriptionBanner from 'src/components/Pages/ArticleParts/ArticleSubscriptionBanner';
import * as ArticleTiles from 'src/components/Pages/ArticleParts/ArticleTiles';
import * as Heading from 'src/components/Pages/ArticleParts/Heading';
import * as HelpArticleBody from 'src/components/Pages/ArticleParts/HelpArticleBody';
import * as HelpNextSteps from 'src/components/Pages/ArticleParts/HelpNextSteps';
import * as KeyHighlightItem from 'src/components/Pages/ArticleParts/KeyHighlightItem';
import * as KeyHighlights from 'src/components/Pages/ArticleParts/KeyHighlights';
import * as NextSteps from 'src/components/Pages/ArticleParts/NextSteps';
import * as NextStepsCommon from 'src/components/Pages/ArticleParts/NextStepsCommon';
import * as Podcast from 'src/components/Pages/ArticleParts/Podcast';
import * as PodcastBase from 'src/components/Pages/ArticleParts/PodcastBase';
import * as PremiumArticleEloquaForm from 'src/components/Pages/ArticleParts/PremiumArticleEloquaForm';
import * as Quote from 'src/components/Pages/ArticleParts/Quote';
import * as RelatedBlock from 'src/components/Pages/ArticleParts/RelatedBlock';
import * as RelatedCapabilities from 'src/components/Pages/ArticleParts/RelatedCapabilities';
import * as RelatedHelpPlatform from 'src/components/Pages/ArticleParts/RelatedHelpPlatform';
import * as RelatedStories from 'src/components/Pages/ArticleParts/RelatedStories';
import * as RelatedStoriesBasic from 'src/components/Pages/ArticleParts/RelatedStoriesBasic';
import * as RelatedTaggedHelp from 'src/components/Pages/ArticleParts/RelatedTaggedHelp';
import * as SpotifyPodcast from 'src/components/Pages/ArticleParts/SpotifyPodcast';
import * as Video from 'src/components/Pages/ArticleParts/Video';
import * as ArticleBody from 'src/components/Pages/ArticleParts/ArticleBody/ArticleBody';
import * as HighlightBlock from 'src/components/Pages/ArticleParts/TextBlocks/HighlightBlock';
import * as Link from 'src/components/Pages/ArticleParts/TextBlocks/Link';
import * as List from 'src/components/Pages/ArticleParts/TextBlocks/List';
import * as Paragraph from 'src/components/Pages/ArticleParts/TextBlocks/Paragraph';
import * as TextBlocks from 'src/components/Pages/ArticleParts/TextBlocks/TextBlocks';
import * as StrategyInFocus from 'src/components/Pages/FundsCenter/StrategyInFocus';
import * as DynamicRelatedArticlesSection from 'src/components/Pages/FundsCenter/AllFunds/DynamicRelatedArticlesSection';
import * as FundCentreMainTabs from 'src/components/Pages/FundsCenter/AllFunds/FundCentreMainTabs';
import * as FundsFiltersSection from 'src/components/Pages/FundsCenter/AllFunds/FundsFilters/FundsFiltersSection';
import * as FundsSearch from 'src/components/Pages/FundsCenter/AllFunds/FundsFilters/FundsSearch';
import * as FundsListing from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsListing';
import * as FundsListingFooter from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsListingFooter';
import * as FundsListingHeading from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsListingHeading';
import * as FundsTable from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTable';
import * as TableSelector from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/TableSelector';
import * as FundsTableRow from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTableParts/FundsTableRow';
import * as FundsTableRowSkeleton from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTableParts/FundsTableRowSkeleton';
import * as FundsThead from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTableParts/FundsThead';
import * as FundsExternalLink from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTableParts/CellParts/FundsExternalLink';
import * as FundsPrice from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTableParts/CellParts/FundsPrice';
import * as FundsShareclassCell from 'src/components/Pages/FundsCenter/AllFunds/FundsListing/FundsTableParts/CellParts/Cells/FundsShareclassCell';
import * as FundDetailsBanner from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsBanner';
import * as FundDetailsBannerSkeleton from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsBannerSkeleton';
import * as FundDetailsImportantInfo from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsImportantInfo';
import * as FundDetailsSecondLevelTabGroup from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsSecondLevelTabGroup';
import * as FundDetailsTabRow from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import * as FundDetailsTabSkeleton from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import * as FundDetailsTabs from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsTabs';
import * as FundDetailsFundsFactsTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsFundsFactsTab';
import * as FundDetailsHoldingsTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsHoldingsTab';
import * as FundDetailsLiteratureTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsLiteratureTab';
import * as FundDetailsManagementTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsManagementTab';
import * as FundDetailsPerformanceDisclaimer from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPerformanceDisclaimer';
import * as FundDetailsPerformanceTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPerformanceTab';
import * as FundDetailsPodcastTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPodcastTab';
import * as FundDetailsStripedTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsStripedTable';
import * as FundDetailsThaiPerformanceTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsThaiPerformanceTab';
import * as BreakdownHOK from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/BreakdownHOK';
import * as FundDetailsBreakdownCountryTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/FundDetailsBreakdownCountryTable';
import * as FundDetailsBreakdownCreditProfileTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/FundDetailsBreakdownCreditProfileTable';
import * as FundDetailsBreakdownMaturityProfileTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/FundDetailsBreakdownMaturityProfileTable';
import * as FundDetailsBreakdownSectorTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/FundDetailsBreakdownSectorTable';
import * as FundDetailsBreakdownTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/FundDetailsBreakdownTab';
import * as FundDetailsPremiumDiscountBarChart from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountBarChart';
import * as FundDetailsPremiumDiscountBarChartCurrentDataTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountBarChartCurrentDataTable';
import * as FundDetailsPremiumDiscountBarChartHistoricalDataTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountBarChartHistoricalDataTable';
import * as FundDetailsPremiumDiscountBarChartSection from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountBarChartSection';
import * as FundDetailsPremiumDiscountLineChart from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountLineChart';
import * as FundDetailsPremiumDiscountLineChartSection from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountLineChartSection';
import * as FundDetailsPremiumDiscountLineChartTable from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountLineChartTable';
import * as FundDetailsPremiumDiscountTab from 'src/components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountTab';
import * as FundDetailsPerformanceTabCumulativeChart from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsPerformanceTabCumulativeSection/FundDetailsPerformanceTabCumulativeChart';
import * as FundDetailsPerformanceTabCumulativeSection from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsPerformanceTabCumulativeSection/FundDetailsPerformanceTabCumulativeSection';
import * as config from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsPerformanceTabCumulativeSection/config';
import * as FundDetailsAuthorisedCountriesTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsAuthorisedCountriesTab';
import * as FundDetailsCodesTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsCodesTab';
import * as FundDetailsCorrelationMatrixTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsCorrelationMatrixTab';
import * as FundDetailsDerivativeTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsDerivativeTab';
import * as FundDetailsKeyInformationTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsKeyInformationTab';
import * as FundDetailsKeyRiskTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsKeyRiskTab';
import * as FundDetailsPortfolioSecuritiesTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsPortfolioSecuritiesTab';
import * as FundDetailsRiskAnalysisTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsRiskAnalysisTab';
import * as FundDetailsTradingInformationTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundDetailsTradingInformationTab';
import * as FundRiskStatisticsTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/FundRiskStatisticsTab';
import * as LiteratureSharedTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/LiteratureSharedTab';
import * as FundDetailsAnnualizedTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsAnnualizedTab';
import * as FundDetailsCalendarTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsCalendarTab';
import * as FundDetailsCumulativeTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsCumulativeTab';
import * as FundDetailsDiscretePerformanceTable from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsDiscretePerformanceTable';
import * as FundDetailsDiscreteTab from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsDiscreteTab';
import * as FundDetailsGeneralPerformanceTable from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsGeneralPerformanceTable';
import * as performanceEndpoints from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/performanceEndpoints';
import * as AnnualizedQuarterlyTable from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedQuarterlyTable';
import * as AnnualizedTable from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedTable';
import * as CumulativeQuarterlyTable from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeQuarterlyTable';
import * as CumulativeTable from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeTable';
import * as PerformanceTableBase from 'src/components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import * as FundDetailsList from 'src/components/Pages/FundsCenter/FundDetails/components/FundDetailsList';
import * as KidsTable from 'src/components/Pages/KidsHub/KidsTable/KidsTable';
import * as PastPerformanceModalContent from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceModalContent';
import * as Benchmarks from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceChart/Benchmarks';
import * as PastPerformanceAside from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceChart/PastPerformanceAside';
import * as PastPerformanceBlock from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceChart/PastPerformanceBlock';
import * as PastPerformanceChart from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceChart/PastPerformanceChart';
import * as XAxisItem from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceChart/XAxisItem';
import * as YAxisValues from 'src/components/Pages/KidsHub/KidsTable/PastPerformanceChart/YAxisValues';
import * as PredictivePerformanceChart from 'src/components/Pages/KidsHub/KidsTable/PredictivePerformanceChart/PredictivePerformanceChart';
import * as DesktopTable from 'src/components/Pages/KidsHub/KidsTable/desktop/DesktopTable';
import * as DesktopTableRow from 'src/components/Pages/KidsHub/KidsTable/desktop/DesktopTableRow';
import * as MobileTable from 'src/components/Pages/KidsHub/KidsTable/mobile/MobileTable';
import * as MobileTableRow from 'src/components/Pages/KidsHub/KidsTable/mobile/MobileTableRow';
import * as types from 'src/components/Pages/KidsHub/KidsTable/shared/types';
import * as useTableRow from 'src/components/Pages/KidsHub/KidsTable/shared/useTableRow';
import * as LiteratureFiltersSection from 'src/components/Pages/LiteratureHub/LiteratureFiltersSection';
import * as LiteratureHub from 'src/components/Pages/LiteratureHub/LiteratureHub';
import * as LiteratureHubTable from 'src/components/Pages/LiteratureHub/LiteratureHubTable';
import * as LiteratureSearch from 'src/components/Pages/LiteratureHub/LiteratureSearch';
import * as FilterBarFunctional from 'src/components/Pages/PressReleases/FilterBarFunctional';
import * as PressReleaseBody from 'src/components/Pages/PressReleases/PressReleaseBody';
import * as PressReleaseCards from 'src/components/Pages/PressReleases/PressReleaseCards';
import * as PressReleaseFilterBar from 'src/components/Pages/PressReleases/PressReleaseFilterBar';
import * as ArticleSeriesBanner from 'src/components/Sections/ArticleSeriesBanner';
import * as ArticleSeriesCollection from 'src/components/Sections/ArticleSeriesCollection';
import * as AutomaticDocumentListings from 'src/components/Sections/AutomaticDocumentListings';
import * as AwardsBanner from 'src/components/Sections/AwardsBanner';
import * as CallOutSection from 'src/components/Sections/CallOutSection';
import * as CustomerReviewsSection from 'src/components/Sections/CustomerReviewsSection';
import * as DescriptiveHighlightSection from 'src/components/Sections/DescriptiveHighlightSection';
import * as DocumentListingBase from 'src/components/Sections/DocumentListingBase';
import * as DocumentListings from 'src/components/Sections/DocumentListings';
import * as EEPlaceholder from 'src/components/Sections/EEPlaceholder';
import * as HighlightSection from 'src/components/Sections/HighlightSection';
import * as LatestPressReleasesSection from 'src/components/Sections/LatestPressReleasesSection';
import * as LogoTextBlocks from 'src/components/Sections/LogoTextBlocks';
import * as MediaBlock from 'src/components/Sections/MediaBlock';
import * as PageLevelTabs from 'src/components/Sections/PageLevelTabs';
import * as PressReleaseHero from 'src/components/Sections/PressReleaseHero';
import * as QuotationBlocks from 'src/components/Sections/QuotationBlocks';
import * as RecentArticles from 'src/components/Sections/RecentArticles';
import * as SectionHeading from 'src/components/Sections/SectionHeading';
import * as SectionSelector from 'src/components/Sections/SectionSelector';
import * as SeriesArticles from 'src/components/Sections/SeriesArticles';
import * as Showcase from 'src/components/Sections/Showcase';
import * as StickyCta from 'src/components/Sections/StickyCta';
import * as TeamProfileCardsWithImages from 'src/components/Sections/TeamProfileCardsWithImages';
import * as Tiles from 'src/components/Sections/Tiles';
import * as Accordion from 'src/components/Sections/Accordion/Accordion';
import * as AccordionDefault from 'src/components/Sections/Accordion/AccordionDefault';
import * as AccordionItem from 'src/components/Sections/Accordion/AccordionItem';
import * as AccordionItems from 'src/components/Sections/Accordion/AccordionItems';
import * as AccordionNew from 'src/components/Sections/Accordion/AccordionNew';
import * as GatedAccordionContainer from 'src/components/Sections/Accordion/GatedAccordionContainer';
import * as FeatureBanner from 'src/components/Sections/Banners/FeatureBanner';
import * as HelpArticleHero from 'src/components/Sections/Banners/HelpArticleHero';
import * as InvestmentsHero from 'src/components/Sections/Banners/InvestmentsHero';
import * as ListingHeroSection from 'src/components/Sections/Banners/ListingHeroSection';
import * as PrimaryHeroBanner from 'src/components/Sections/Banners/PrimaryHeroBanner';
import * as SecondaryHeroBanner from 'src/components/Sections/Banners/SecondaryHeroBanner';
import * as TertieryHeroBanner from 'src/components/Sections/Banners/TertieryHeroBanner';
import * as ArticleAuthors from 'src/components/Sections/Banners/ArticleHero/ArticleAuthors';
import * as ArticleContributors from 'src/components/Sections/Banners/ArticleHero/ArticleContributors';
import * as ArticleHero from 'src/components/Sections/Banners/ArticleHero/ArticleHero';
import * as ArticleHeroImageBackground from 'src/components/Sections/Banners/ArticleHero/ArticleHeroImageBackground';
import * as ArticleHeroTypes from 'src/components/Sections/Banners/ArticleHero/ArticleHeroTypes';
import * as ArticleAuthor from 'src/components/Sections/Banners/ArticleHero/ArticleAuthor/ArticleAuthor';
import * as ArticleHeroImageRight from 'src/components/Sections/Banners/ArticleHero/ArticleHeroImageRight/ArticleHeroImageRight';
import * as EloquaForm from 'src/components/Sections/EloquaForm/EloquaForm';
import * as HoneypotField from 'src/components/Sections/EloquaForm/HoneypotField';
import * as Rows from 'src/components/Sections/EloquaForm/Rows';
import * as FormsSharedFields from 'src/components/Sections/Forms/FormsSharedFields';
import * as ArticlesSectionComponent from 'src/components/Sections/RelatedArticlesVariations/ArticlesSectionComponent';
import * as FeaturedArticlesSection from 'src/components/Sections/RelatedArticlesVariations/FeaturedArticlesSection';
import * as FeaturedThemeSection from 'src/components/Sections/RelatedArticlesVariations/FeaturedThemeSection';
import * as LatestArticlesSection from 'src/components/Sections/RelatedArticlesVariations/LatestArticlesSection';
import * as RelatedArticlesSection from 'src/components/Sections/RelatedArticlesVariations/RelatedArticlesSection';
import * as RelatedHelpArticlesSection from 'src/components/Sections/RelatedArticlesVariations/RelatedHelpArticlesSection';
import * as RiskWarning from 'src/components/Sections/RiskWarning/RiskWarning';
import * as RiskWarningtypes from 'src/components/Sections/RiskWarning/RiskWarning.types';
import * as RiskWarningContent from 'src/components/Sections/RiskWarning/RiskWarningContent';
import * as Articles from 'src/components/Sections/TableOfContents/Articles';
import * as Sidebar from 'src/components/Sections/TableOfContents/Sidebar';
import * as TableOfContents from 'src/components/Sections/TableOfContents/TableOfContents';
import * as TeamMemberBanner from 'src/components/Sections/TeamMemberBiography/TeamMemberBanner';
import * as TeamMemberBiography from 'src/components/Sections/TeamMemberBiography/TeamMemberBiography';
import * as TeamMemberContactLinks from 'src/components/Sections/TeamMemberBiography/TeamMemberContactLinks';
import * as SideTile from 'src/components/Sections/Tiles/SideTile';
import * as Tile from 'src/components/Sections/Tiles/Tile';
import * as ArticleCard from 'src/components/Tiles/ArticleCard';
import * as ArticleCardHorizontal from 'src/components/Tiles/ArticleCardHorizontal';
import * as ArticleSeriesCard from 'src/components/Tiles/ArticleSeriesCard';
import * as CustomerReviewTile from 'src/components/Tiles/CustomerReviewTile';
import * as DescriptiveHighlightTile from 'src/components/Tiles/DescriptiveHighlightTile';
import * as HelpArticleTile from 'src/components/Tiles/HelpArticleTile';
import * as HighlightItem from 'src/components/Tiles/HighlightItem';
import * as PressReleaseCard from 'src/components/Tiles/PressReleaseCard';
import * as PressReleaseCardAdapter from 'src/components/Tiles/PressReleaseCardAdapter';
import * as RelatedArticleTile from 'src/components/Tiles/RelatedArticleTile';
import * as TeamProfileCard from 'src/components/Tiles/TeamProfileCard';
import * as VectorTile from 'src/components/Tiles/VectorTile';
import * as DisplayingRange from 'src/components/includes/DisplayingRange';
import * as LoadMoreButton from 'src/components/includes/LoadMoreButton';
import * as Pagination from 'src/components/includes/Pagination';
import * as Rating from 'src/components/includes/Rating';
import * as Readtime from 'src/components/includes/Readtime';
import * as SocialNetwork from 'src/components/includes/SocialNetwork';
import * as Badge from 'src/components/includes/Badge/Badge';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('CallToAction', CallToAction);
components.set('CdpPageView', CdpPageView);
components.set('ContentBlock', ContentBlock);
components.set('FEAASScripts', FEAASScripts);
components.set('GTM', GTM);
components.set('OneTrust', OneTrust);
components.set('BannerQuickLinks', BannerQuickLinks);
components.set('IFrame', IFrame);
components.set('Infographics', Infographics);
components.set('CustomScroll', CustomScroll);
components.set('Tabs', Tabs);
components.set('ArticleFilters', ArticleFilters);
components.set('SelectedFilters', SelectedFilters);
components.set('BaseFilter', BaseFilter);
components.set('DatePickerFilter', DatePickerFilter);
components.set('FilterDropdown', FilterDropdown);
components.set('FilterDropdownOption', FilterDropdownOption);
components.set('MobileBaseFilters', MobileBaseFilters);
components.set('MobileBaseFiltersActions', MobileBaseFiltersActions);
components.set('MobileBaseFiltersDropdown', MobileBaseFiltersDropdown);
components.set('MobileBaseFiltersDropdownOption', MobileBaseFiltersDropdownOption);
components.set('Slider', Slider);
components.set('SliderNavCircle', SliderNavCircle);
components.set('AlertMessage', AlertMessage);
components.set('AlertMessageBase', AlertMessageBase);
components.set('Animation', Animation);
components.set('ArticleCardsComponent', ArticleCardsComponent);
components.set('AsideModal', AsideModal);
components.set('BaseHeading', BaseHeading);
components.set('BaseSkeleton', BaseSkeleton);
components.set('Breadcrumbs', Breadcrumbs);
components.set('Checkbox', Checkbox);
components.set('Dropdown', Dropdown);
components.set('ExpandableContent', ExpandableContent);
components.set('FirstLevelTabs', FirstLevelTabs);
components.set('Footer', Footer);
components.set('IntroCopy', IntroCopy);
components.set('ManualDisclaimer', ManualDisclaimer);
components.set('SecondLevelTabs', SecondLevelTabs);
components.set('ShareScreen', ShareScreen);
components.set('SkipToMainContent', SkipToMainContent);
components.set('StateDrivenDropdown', StateDrivenDropdown);
components.set('TeamProfileBase', TeamProfileBase);
components.set('Tooltip', Tooltip);
components.set('AbrdnButton', AbrdnButton);
components.set('BackToTopButton', BackToTopButton);
components.set('ContainerMain', ContainerMain);
components.set('AbrdnSelect', AbrdnSelect);
components.set('DatePicker', DatePicker);
components.set('FormCheckbox', FormCheckbox);
components.set('FormElemWrapper', FormElemWrapper);
components.set('InputField', InputField);
components.set('MultipleCheckboxes', MultipleCheckboxes);
components.set('MultiplePicklist', MultiplePicklist);
components.set('Note', Note);
components.set('RadioButton', RadioButton);
components.set('RadioButtonFieldset', RadioButtonFieldset);
components.set('FieldTypeDefiner', FieldTypeDefiner);
components.set('FormContext', FormContext);
components.set('RepeatableSectionFieldDefiner', RepeatableSectionFieldDefiner);
components.set('SalesforceIntegratedForm', SalesforceIntegratedForm);
components.set('StepProgress', StepProgress);
components.set('StepSelector', StepSelector);
components.set('Summary', Summary);
components.set('WithFormProvider', WithFormProvider);
components.set('SalesforceAlertMessage', SalesforceAlertMessage);
components.set('SalesforceCheckBox', SalesforceCheckBox);
components.set('SalesforceConditionalRadioButtons', SalesforceConditionalRadioButtons);
components.set('SalesforceDateInput', SalesforceDateInput);
components.set('SalesforceDropdown', SalesforceDropdown);
components.set('SalesforceHiddenField', SalesforceHiddenField);
components.set('SalesforceInput', SalesforceInput);
components.set('SalesforceRepeatableSubSection', SalesforceRepeatableSubSection);
components.set('SalesforceRichTextArea', SalesforceRichTextArea);
components.set('SalesforceSortCode', SalesforceSortCode);
components.set('TemplateComponentType', TemplateComponentType);
components.set('fieldsMapping', fieldsMapping);
components.set('Header', Header);
components.set('LanguageSelector', LanguageSelector);
components.set('GlobalNavigation', GlobalNavigation);
components.set('GlobalNavigationDropdown', GlobalNavigationDropdown);
components.set('SiteSelector', SiteSelector);
components.set('LanguageSelectorMobile', LanguageSelectorMobile);
components.set('MegaNavigation', MegaNavigation);
components.set('MegaNavigation.types', MegaNavigationtypes);
components.set('MegaNavigationBody', MegaNavigationBody);
components.set('MegaNavigationBodyMobile', MegaNavigationBodyMobile);
components.set('MegaNavigationMenuItem', MegaNavigationMenuItem);
components.set('MobileMenuSiteSelector', MobileMenuSiteSelector);
components.set('PromotedContent', PromotedContent);
components.set('changeLanguage', changeLanguage);
components.set('changeSite', changeSite);
components.set('IconChevronQuickLinks', IconChevronQuickLinks);
components.set('IconStar', IconStar);
components.set('IconWarning', IconWarning);
components.set('IconX', IconX);
components.set('TeamProfilePlaceholder', TeamProfilePlaceholder);
components.set('index', index);
components.set('BaseSearch', BaseSearch);
components.set('BaseSearchSuggests', BaseSearchSuggests);
components.set('AbrdnPlaceholders', AbrdnPlaceholders);
components.set('Image', Image);
components.set('RichText', RichText);
components.set('ScLink', ScLink);
components.set('DisclaimerModal', DisclaimerModal);
components.set('DisclaimerModalContent', DisclaimerModalContent);
components.set('Modal', Modal);
components.set('ModalBody', ModalBody);
components.set('ModalContent', ModalContent);
components.set('ModalHeader', ModalHeader);
components.set('ShareModalContent', ShareModalContent);
components.set('ArticleCards', ArticleCards);
components.set('ArticleFilterBar', ArticleFilterBar);
components.set('FilteredArticleCards', FilteredArticleCards);
components.set('ArticleActionBar', ArticleActionBar);
components.set('ArticleBottomContainer', ArticleBottomContainer);
components.set('ArticleChapters', ArticleChapters);
components.set('ArticleFootnote', ArticleFootnote);
components.set('ArticleInfogramTile', ArticleInfogramTile);
components.set('ArticleSubscriptionBanner', ArticleSubscriptionBanner);
components.set('ArticleTiles', ArticleTiles);
components.set('Heading', Heading);
components.set('HelpArticleBody', HelpArticleBody);
components.set('HelpNextSteps', HelpNextSteps);
components.set('KeyHighlightItem', KeyHighlightItem);
components.set('KeyHighlights', KeyHighlights);
components.set('NextSteps', NextSteps);
components.set('NextStepsCommon', NextStepsCommon);
components.set('Podcast', Podcast);
components.set('PodcastBase', PodcastBase);
components.set('PremiumArticleEloquaForm', PremiumArticleEloquaForm);
components.set('Quote', Quote);
components.set('RelatedBlock', RelatedBlock);
components.set('RelatedCapabilities', RelatedCapabilities);
components.set('RelatedHelpPlatform', RelatedHelpPlatform);
components.set('RelatedStories', RelatedStories);
components.set('RelatedStoriesBasic', RelatedStoriesBasic);
components.set('RelatedTaggedHelp', RelatedTaggedHelp);
components.set('SpotifyPodcast', SpotifyPodcast);
components.set('Video', Video);
components.set('ArticleBody', ArticleBody);
components.set('HighlightBlock', HighlightBlock);
components.set('Link', Link);
components.set('List', List);
components.set('Paragraph', Paragraph);
components.set('TextBlocks', TextBlocks);
components.set('StrategyInFocus', StrategyInFocus);
components.set('DynamicRelatedArticlesSection', DynamicRelatedArticlesSection);
components.set('FundCentreMainTabs', FundCentreMainTabs);
components.set('FundsFiltersSection', FundsFiltersSection);
components.set('FundsSearch', FundsSearch);
components.set('FundsListing', FundsListing);
components.set('FundsListingFooter', FundsListingFooter);
components.set('FundsListingHeading', FundsListingHeading);
components.set('FundsTable', FundsTable);
components.set('TableSelector', TableSelector);
components.set('FundsTableRow', FundsTableRow);
components.set('FundsTableRowSkeleton', FundsTableRowSkeleton);
components.set('FundsThead', FundsThead);
components.set('FundsExternalLink', FundsExternalLink);
components.set('FundsPrice', FundsPrice);
components.set('FundsShareclassCell', FundsShareclassCell);
components.set('FundDetailsBanner', FundDetailsBanner);
components.set('FundDetailsBannerSkeleton', FundDetailsBannerSkeleton);
components.set('FundDetailsImportantInfo', FundDetailsImportantInfo);
components.set('FundDetailsSecondLevelTabGroup', FundDetailsSecondLevelTabGroup);
components.set('FundDetailsTabRow', FundDetailsTabRow);
components.set('FundDetailsTabSkeleton', FundDetailsTabSkeleton);
components.set('FundDetailsTabs', FundDetailsTabs);
components.set('FundDetailsFundsFactsTab', FundDetailsFundsFactsTab);
components.set('FundDetailsHoldingsTab', FundDetailsHoldingsTab);
components.set('FundDetailsLiteratureTab', FundDetailsLiteratureTab);
components.set('FundDetailsManagementTab', FundDetailsManagementTab);
components.set('FundDetailsPerformanceDisclaimer', FundDetailsPerformanceDisclaimer);
components.set('FundDetailsPerformanceTab', FundDetailsPerformanceTab);
components.set('FundDetailsPodcastTab', FundDetailsPodcastTab);
components.set('FundDetailsStripedTable', FundDetailsStripedTable);
components.set('FundDetailsThaiPerformanceTab', FundDetailsThaiPerformanceTab);
components.set('BreakdownHOK', BreakdownHOK);
components.set('FundDetailsBreakdownCountryTable', FundDetailsBreakdownCountryTable);
components.set('FundDetailsBreakdownCreditProfileTable', FundDetailsBreakdownCreditProfileTable);
components.set('FundDetailsBreakdownMaturityProfileTable', FundDetailsBreakdownMaturityProfileTable);
components.set('FundDetailsBreakdownSectorTable', FundDetailsBreakdownSectorTable);
components.set('FundDetailsBreakdownTab', FundDetailsBreakdownTab);
components.set('FundDetailsPremiumDiscountBarChart', FundDetailsPremiumDiscountBarChart);
components.set('FundDetailsPremiumDiscountBarChartCurrentDataTable', FundDetailsPremiumDiscountBarChartCurrentDataTable);
components.set('FundDetailsPremiumDiscountBarChartHistoricalDataTable', FundDetailsPremiumDiscountBarChartHistoricalDataTable);
components.set('FundDetailsPremiumDiscountBarChartSection', FundDetailsPremiumDiscountBarChartSection);
components.set('FundDetailsPremiumDiscountLineChart', FundDetailsPremiumDiscountLineChart);
components.set('FundDetailsPremiumDiscountLineChartSection', FundDetailsPremiumDiscountLineChartSection);
components.set('FundDetailsPremiumDiscountLineChartTable', FundDetailsPremiumDiscountLineChartTable);
components.set('FundDetailsPremiumDiscountTab', FundDetailsPremiumDiscountTab);
components.set('FundDetailsPerformanceTabCumulativeChart', FundDetailsPerformanceTabCumulativeChart);
components.set('FundDetailsPerformanceTabCumulativeSection', FundDetailsPerformanceTabCumulativeSection);
components.set('config', config);
components.set('FundDetailsAuthorisedCountriesTab', FundDetailsAuthorisedCountriesTab);
components.set('FundDetailsCodesTab', FundDetailsCodesTab);
components.set('FundDetailsCorrelationMatrixTab', FundDetailsCorrelationMatrixTab);
components.set('FundDetailsDerivativeTab', FundDetailsDerivativeTab);
components.set('FundDetailsKeyInformationTab', FundDetailsKeyInformationTab);
components.set('FundDetailsKeyRiskTab', FundDetailsKeyRiskTab);
components.set('FundDetailsPortfolioSecuritiesTab', FundDetailsPortfolioSecuritiesTab);
components.set('FundDetailsRiskAnalysisTab', FundDetailsRiskAnalysisTab);
components.set('FundDetailsTradingInformationTab', FundDetailsTradingInformationTab);
components.set('FundRiskStatisticsTab', FundRiskStatisticsTab);
components.set('LiteratureSharedTab', LiteratureSharedTab);
components.set('FundDetailsAnnualizedTab', FundDetailsAnnualizedTab);
components.set('FundDetailsCalendarTab', FundDetailsCalendarTab);
components.set('FundDetailsCumulativeTab', FundDetailsCumulativeTab);
components.set('FundDetailsDiscretePerformanceTable', FundDetailsDiscretePerformanceTable);
components.set('FundDetailsDiscreteTab', FundDetailsDiscreteTab);
components.set('FundDetailsGeneralPerformanceTable', FundDetailsGeneralPerformanceTable);
components.set('performanceEndpoints', performanceEndpoints);
components.set('AnnualizedQuarterlyTable', AnnualizedQuarterlyTable);
components.set('AnnualizedTable', AnnualizedTable);
components.set('CumulativeQuarterlyTable', CumulativeQuarterlyTable);
components.set('CumulativeTable', CumulativeTable);
components.set('PerformanceTableBase', PerformanceTableBase);
components.set('FundDetailsList', FundDetailsList);
components.set('KidsTable', KidsTable);
components.set('PastPerformanceModalContent', PastPerformanceModalContent);
components.set('Benchmarks', Benchmarks);
components.set('PastPerformanceAside', PastPerformanceAside);
components.set('PastPerformanceBlock', PastPerformanceBlock);
components.set('PastPerformanceChart', PastPerformanceChart);
components.set('XAxisItem', XAxisItem);
components.set('YAxisValues', YAxisValues);
components.set('PredictivePerformanceChart', PredictivePerformanceChart);
components.set('DesktopTable', DesktopTable);
components.set('DesktopTableRow', DesktopTableRow);
components.set('MobileTable', MobileTable);
components.set('MobileTableRow', MobileTableRow);
components.set('types', types);
components.set('useTableRow', useTableRow);
components.set('LiteratureFiltersSection', LiteratureFiltersSection);
components.set('LiteratureHub', LiteratureHub);
components.set('LiteratureHubTable', LiteratureHubTable);
components.set('LiteratureSearch', LiteratureSearch);
components.set('FilterBarFunctional', FilterBarFunctional);
components.set('PressReleaseBody', PressReleaseBody);
components.set('PressReleaseCards', PressReleaseCards);
components.set('PressReleaseFilterBar', PressReleaseFilterBar);
components.set('ArticleSeriesBanner', ArticleSeriesBanner);
components.set('ArticleSeriesCollection', ArticleSeriesCollection);
components.set('AutomaticDocumentListings', AutomaticDocumentListings);
components.set('AwardsBanner', AwardsBanner);
components.set('CallOutSection', CallOutSection);
components.set('CustomerReviewsSection', CustomerReviewsSection);
components.set('DescriptiveHighlightSection', DescriptiveHighlightSection);
components.set('DocumentListingBase', DocumentListingBase);
components.set('DocumentListings', DocumentListings);
components.set('EEPlaceholder', EEPlaceholder);
components.set('HighlightSection', HighlightSection);
components.set('LatestPressReleasesSection', LatestPressReleasesSection);
components.set('LogoTextBlocks', LogoTextBlocks);
components.set('MediaBlock', MediaBlock);
components.set('PageLevelTabs', PageLevelTabs);
components.set('PressReleaseHero', PressReleaseHero);
components.set('QuotationBlocks', QuotationBlocks);
components.set('RecentArticles', RecentArticles);
components.set('SectionHeading', SectionHeading);
components.set('SectionSelector', SectionSelector);
components.set('SeriesArticles', SeriesArticles);
components.set('Showcase', Showcase);
components.set('StickyCta', StickyCta);
components.set('TeamProfileCardsWithImages', TeamProfileCardsWithImages);
components.set('Tiles', Tiles);
components.set('Accordion', Accordion);
components.set('AccordionDefault', AccordionDefault);
components.set('AccordionItem', AccordionItem);
components.set('AccordionItems', AccordionItems);
components.set('AccordionNew', AccordionNew);
components.set('GatedAccordionContainer', GatedAccordionContainer);
components.set('FeatureBanner', FeatureBanner);
components.set('HelpArticleHero', HelpArticleHero);
components.set('InvestmentsHero', InvestmentsHero);
components.set('ListingHeroSection', ListingHeroSection);
components.set('PrimaryHeroBanner', PrimaryHeroBanner);
components.set('SecondaryHeroBanner', SecondaryHeroBanner);
components.set('TertieryHeroBanner', TertieryHeroBanner);
components.set('ArticleAuthors', ArticleAuthors);
components.set('ArticleContributors', ArticleContributors);
components.set('ArticleHero', ArticleHero);
components.set('ArticleHeroImageBackground', ArticleHeroImageBackground);
components.set('ArticleHeroTypes', ArticleHeroTypes);
components.set('ArticleAuthor', ArticleAuthor);
components.set('ArticleHeroImageRight', ArticleHeroImageRight);
components.set('EloquaForm', EloquaForm);
components.set('HoneypotField', HoneypotField);
components.set('Rows', Rows);
components.set('FormsSharedFields', FormsSharedFields);
components.set('ArticlesSectionComponent', ArticlesSectionComponent);
components.set('FeaturedArticlesSection', FeaturedArticlesSection);
components.set('FeaturedThemeSection', FeaturedThemeSection);
components.set('LatestArticlesSection', LatestArticlesSection);
components.set('RelatedArticlesSection', RelatedArticlesSection);
components.set('RelatedHelpArticlesSection', RelatedHelpArticlesSection);
components.set('RiskWarning', RiskWarning);
components.set('RiskWarning.types', RiskWarningtypes);
components.set('RiskWarningContent', RiskWarningContent);
components.set('Articles', Articles);
components.set('Sidebar', Sidebar);
components.set('TableOfContents', TableOfContents);
components.set('TeamMemberBanner', TeamMemberBanner);
components.set('TeamMemberBiography', TeamMemberBiography);
components.set('TeamMemberContactLinks', TeamMemberContactLinks);
components.set('SideTile', SideTile);
components.set('Tile', Tile);
components.set('ArticleCard', ArticleCard);
components.set('ArticleCardHorizontal', ArticleCardHorizontal);
components.set('ArticleSeriesCard', ArticleSeriesCard);
components.set('CustomerReviewTile', CustomerReviewTile);
components.set('DescriptiveHighlightTile', DescriptiveHighlightTile);
components.set('HelpArticleTile', HelpArticleTile);
components.set('HighlightItem', HighlightItem);
components.set('PressReleaseCard', PressReleaseCard);
components.set('PressReleaseCardAdapter', PressReleaseCardAdapter);
components.set('RelatedArticleTile', RelatedArticleTile);
components.set('TeamProfileCard', TeamProfileCard);
components.set('VectorTile', VectorTile);
components.set('DisplayingRange', DisplayingRange);
components.set('LoadMoreButton', LoadMoreButton);
components.set('Pagination', Pagination);
components.set('Rating', Rating);
components.set('Readtime', Readtime);
components.set('SocialNetwork', SocialNetwork);
components.set('Badge', Badge);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
